import Grid from "@material-ui/core/Grid";
import styles from "../orderDetailsActionNotifications/OrderDetailsActionNotifications.module.scss";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React from "react";

export const OrderDetailsNotification = (props) => {
  return (
    <div data-testid="viewDetailsNotification">
      <Grid
        container
        className={
          props.warningColor
            ? `${styles.actionNotificationBox} ${styles.warningBoxColor}`
            : `${styles.actionNotificationBox} ${styles.whiteBoxColor}`
        }
      >
        <Grid item xs={1} className={styles.actionNotificationText}>
          {props.warningColor ? (
            <div className={styles.actionWarningIcon} />
          ) : (
            <InfoOutlinedIcon className={styles.alignPadding} />
          )}
        </Grid>
        <Grid item xs={3} className={styles.actionNotificationText}>
          <div>{props.showActionRequired}</div>
        </Grid>
        <Grid item xs={7} className={styles.actionNotificationText}>
          <div>{props.showMessage}</div>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </div>
  );
};
